import { useRecord } from "./useRecord";

export function useMessageReactions(props: { messageId: string | null | undefined }) {
  return useRecord("message_reactions", props.messageId, { name: "useMessageReactions" });
}
